import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiCard
 *
 * Demos:
 *
 * - [Card](https://ui-packages.isbuildingluma.com/ui-core/react-card/)
 *
 * API:
 *
 * - [Card API](https://ui-packages.isbuildingluma.com/ui-core/api/card/)
 * - inherits [MuiCard API](https://mui.com/material-ui/api/card/)
 */
const MuiCard = {
  defaultProps: {
    elevation: 0
  },
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => ({
      '&:hover': _extends({}, ownerState.onClick && {
        boxShadow: theme.shadows[2]
      })
    })
  }
};
export const MuiCardHeader = {
  styleOverrides: {
    title: {
      fontWeight: 600,
      fontSize: 18
    },
    action: {
      margin: 0
    }
  }
};
export const MuiCardActionArea = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&:hover .MuiCardActionArea-focusHighlight': {
        opacity: 0
      },
      '&:active': {
        background: theme.palette.background.default
      }
    }),
    focusHighlight: ({
      theme
    }) => ({
      background: theme.palette.primary.light
    })
  }
};
export default MuiCard;